import { render, staticRenderFns } from "./ProfileAffiliateChart.vue?vue&type=template&id=47bcd03e&scoped=true&"
import script from "./ProfileAffiliateChart.vue?vue&type=script&lang=ts&"
export * from "./ProfileAffiliateChart.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAffiliateChart.vue?vue&type=style&index=0&id=47bcd03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcd03e",
  null
  
)

export default component.exports